
// クリップボードにコピー
export function onClickCopy() {
    // コピー対象オブジェクトを取得する.
    let pTag = document.getElementById('copyTarget');
    // コピー内容を選択する.
    let range = document.createRange();
    range.selectNodeContents(pTag);
    let selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    // 選択したものをコピーする.
    document.execCommand('copy');
    // コピー内容の選択を解除する.
    selection.removeAllRanges();
}

// バイト変換
export function readablizeBytes(bytes) {
    if (Number.isFinite(bytes)) {
        var s = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'];
        var e = Math.floor(Math.log(bytes) / Math.log(1024));
        return (bytes / Math.pow(1024, e)).toFixed(2) + " " + s[e];
    } else {
        return '';
    }
}

// 秒変換　→　年、日、時間、分、秒
export function secondsToStr(temp) {
    if (Number.isFinite(temp)) {
        var years = Math.floor(temp / 31536000);
        if (years) {
            return 'あと ' + years + ' 年';
        }
        var days = Math.floor(temp / (24 * 60 * 60));
        if (days) {
            return 'あと ' + days + ' 日';
        }
        var hours = Math.floor(temp % (24 * 60 * 60) / (60 * 60));
        if (hours) {
            return 'あと ' + hours + ' 時間';
        }
        var minutes = Math.floor(temp % (24 * 60 * 60) % (60 * 60) / 60);
        if (minutes) {
            return 'あと ' + minutes + ' 分';
        }
        var seconds = temp;
        return 'あと ' + seconds + ' 秒';
    } else {
        return '';
    }

    /*
    if (Number.isFinite(temp)) {
        var years = Math.floor(temp / 31536000);
        if (years) {
            return 'あと ' + years + ' 年';
        }
        var days = Math.floor((temp %= 31536000) / 86400);
        if (days) {
            return 'あと ' + days + ' 日';
        }
        var hours = Math.floor((temp %= 86400) / 3600);
        if (hours) {
            return 'あと ' + hours + ' 時間';
        }
        var minutes = Math.floor((temp %= 3600) / 60);
        if (minutes) {
            return 'あと ' + minutes + ' 分';
        }
        var seconds = temp % 60;
        return 'あと ' + seconds + ' 秒';
    } else {
        return '';
    }
    */
}

// ユニークID作成
/*
export function getUniqueStr(myStrong) {
    var strong = 1000;
    if (myStrong) strong = myStrong;
    return new Date().getTime().toString(16) + Math.floor(strong * Math.random()).toString(16)
}
*/
// ユニークID作成
export function getUniqueStr() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
};